import React, { Component } from 'react';
import '../styles/Servicio.css';
import styled from 'styled-components'
import bannerService from '../images/servicios/servicios-banner.png'
import Banner from './Banner'
import ShowMore from './ShowMore'
import comercialesImg from '../icons/servicios/comercial-icon.svg'
import logisticaImg from '../icons/servicios/logistica.svg'
import pcImg from '../icons/servicios/pc.svg'
import administrativoImg from '../icons/servicios/tabla.svg'
import iconConvenios from '../icons/servicios/iconConvenios.svg'
import downloadIcon from '../icons/servicios/descargar.svg'
import ScrollTop from './ScrollTop'
import Analytics from './Analytics'

const ShowMoreWithStyles = styled.img`
    display: block;
    padding-top: 20px;
    margin: auto;
    height: 30px;
    width: 30px;
    cursor: pointer;
`

class Servicio extends Component {
    changeColorTitle(idtitle){
        let title = document.getElementById(idtitle)
        
        if(title.classList.contains("colorTitle")){
            title.style.color = "#4a4a4a";
            title.classList.remove("colorTitle")
        }else{
            title.style.color = "#ff8400"
            title.classList.add("colorTitle")
        }
    }
    getDownloadBrochure(){
        return (
        <div class="download-service">
            <a href="/brochure/Brochure_GF.pdf" download> 
                <img src={downloadIcon} class="download-img"/>
            </a>
            <p class="download-text">Descargar brochure</p>
        </div>
        );
    }
    render(){
        return (
            <div className="Servicio">
                <ScrollTop />
                <Analytics />
                <Banner className="banner-servicios-container" title="Nuestros servicios"
                     description="Somos Flexibles por que nacimos flexibles" 
                      imageBanner={bannerService} />
                <div class="service-content">
                    <div class="service-content-item">
                        <img src={comercialesImg} class="icon-service"/>
                        <div>
                            <h2 id="titleCom">Comerciales</h2>
                            <ul>
                                <li>Un equipo especializado para la atención de todos los canales comerciales que garantizan una negociación acorde a las políticas de cada cliente en forma individual.</li>
                                
                            <span id="text-service-comercial" className="hide-resize">
                                <li>Servicio comercial a medida que permite llevar al mercado cada uno de los requerimientos que su negocio necesita.</li>
                                <li>Presencia diaria de nuestros representantes comerciales en las principales Droguerías.</li>
                                <li>Todos los meses dispondrá de un informe comercial de la situación particular y del mercado con información sensible para su negocio. </li>
                            <span id="textComercialDesktop" class="hide-desktop">
                                
                                    <li>Cierres de venta determinado por el Laboratorio.</li>
                                    <li>Telemarketing.</li>
                                    <li>Seguimiento especial de los key-products.</li>
                                    <li>Información de stock y ventas de Droguerías.</li>
                                    <li>Presentación mensual de análisis y proyección desarrollada especialmente para cada Laboratorio.</li>
                                    <li>Atención y negociación con Droguerías y principales Farmacias.</li>
                                    <li>Gestión de venta y cobranza.</li>
                                    <li>Gestión de transfers</li>
                                    <li>Condiciones de venta por Laboratorio, producto y Droguería (descuentos, plazos, ofertas, colocaciones de productos, transfers).</li>
                                    <li>Transmisión electrónica de pedidos desde las Droguerías.</li>
                                </span>
                            </span>
                            </ul>
                            <div class="show-more-desktop">
                                <ShowMore textId="textComercialDesktop" loadEffect={true} component={ShowMoreWithStyles} onClick={() => this.changeColorTitle("titleCom")}/>
                            </div>
                        </div>
                    </div>
                    <div class="show-more-service">
                        <ShowMore textId="text-service-comercial" loadEffect={true}/>
                    </div>
                    <hr class="line-separator" />
                    
                    
                    <div class="service-content-item">
                        <img src={iconConvenios} class="icon-service"/>
                        <div>
                            <h2 id="titleConven">Finanzas</h2>
                            <ul>
                                <li>La administración de la cobranzas y cuentas corrientes está asistida por nuestro personal capacitado que hace un seguimiento diario con cada uno de los clientes, garantizando la actualización diaria, con acceso on-line.</li>
                                
                            <span id="text-service-convenio" className="hide-resize">
                            <li>Dispondrá de los fondos cobrados el mismo día que se acreditan en Globalfarm por medio de transferencia electrónica.</li>
                                <li>Disponibilidad de la factura de líquido producto al día siguiente al cierre de su operación.</li>
                            <span id="textConvenioDesktop" class="hide-desktop">
                                <li>Límites de créditos y condiciones comerciales individuales y definidas por cada laboratorio.</li>
                                <li>Validación de condiciones comerciales en forma automática, las excepciones son aprobadas por los laboratorios en forma on-line.</li>
                                <li>Reportes de riesgo crediticio para los principales clientes.</li>
                                <li>Manejo de convenios especiales, administración e información de stock en Droguerías Especiales.</li>
                                </span>
                            </span>
                            </ul>
                            <div class="show-more-desktop">
                                <ShowMore textId="textConvenioDesktop" loadEffect={true} component={ShowMoreWithStyles} onClick={() => this.changeColorTitle("titleConven")}/>
                            </div>
                        </div>
                    </div>
                    <div class="show-more-service">
                        <ShowMore textId="text-service-convenio" loadEffect={true}/>
                    </div>
                    <hr class="line-separator" />
                    
                    <div class="service-content-item">
                        <img src={logisticaImg} class="icon-service"/>
                        <div>
                            <h2 id="titleLog">Logística</h2>
                            <ul>
                                <li>Depósito de 14.000 mts2 con temperatura y humedad controlada.</li>
                                <li>Retiro de productos donde indique el Laboratorio.</li>
                            <span id="text-service-logis" className="hide-resize">
                                <li>Almacenamiento en depósitos con temperatura controlada en su totalidad y con división de áreas especiales.</li>
                            <span id="textLogDesktop" class="hide-desktop">
                                <li>Línea General. </li>
                                <li>Psicotrópicos. </li>
                                <li>Productos de Alto valor. </li>
                                <li>Cadena de frío con cámara (2º/8º) y ante-cámara (14º) para preparación. </li>
                                <li>Aerosoles.</li>
                                <li>Reactivos de diagnóstico. </li>
                                <li>Alimentos. </li>
                                <li>Ensayos Clínicos. </li>
                                <li>Gestión de stocks por sistema de radiofrecuencia. </li>
                                <li>Control de stock por producto y lote actualizado on-line. </li>
                                <li>Cuarentena en área aislada. </li>
                                <li>Recepción y acondicionamiento de productos importados. </li>
                                <li>Impresión de remitos, facturas y recibos en Planta. </li>
                                <li>Manejo de material de Clinical Trials. </li>
                                <li>Cobranza contra entrega. </li>
                                <li>Trazabilidad de lotes (recall). </li>
                                <li>Vigilancia satelital y seguimiento de envíos. </li>
                                <li>Envíos con cadena de frío validados a través de sensores en cada uno de ellos. </li>
                                <li>Envíos por vía aérea a más de 600 Km. en caso de productos refrigerados. </li>
                                <li>Atención de urgencias en todo el país. </li>
                                <li>Análisis y procesamiento de las devoluciones.</li>
                            </span>
                            </span>
                            </ul>
                            <div class="show-more-desktop">
                                <ShowMore textId="textLogDesktop" loadEffect={true} component={ShowMoreWithStyles} onClick={() => this.changeColorTitle("titleLog")}/>
                            </div>
                        </div>
                    </div>
                    <div class="show-more-service">
                        <ShowMore textId="text-service-logis" loadEffect={true}/>
                    </div>
                    <div class="line-separator"></div>
                    <div class="service-content-item">
                        <img src={pcImg} class="icon-service"/>
                        <div>
                            <h2 id="titleTec">Tecnología de la información</h2>
                            <span id="text-service-tec" className="hide-resize">
                            <ul>
                                <li>Un grupo de profesionales altamente capacitados para proveer las herramientas que satisfacen las necesidades del negocio. </li>
                                <li>Conozca el estado de su negocio en el momento y lugar que necesite accediendo a nuestro sistema on-line. </li>
                            <span id="textTecDesktop" class="hide-desktop">	
                                <li>Sistemas y equipamiento de última generación.</li>
                                <li>Data Center duplicado para contingencias.</li>
                                <li>Plan de Continuidad de Negocios, doble centro de cómputos en diferentes locaciones, UPS y generadores propios. </li>
                                <li>Información diaria electrónica de la gestión para alimentar los sistemas propios del Laboratorio. </li>
                                <li>Capacitación periódica a los usuarios de los Laboratorios. </li>
                                <li>Sistema on-line en entorno Windows de acceso desde cualquier lado con cualquier dispositivo.</li>
                                <li>Aplicaciones para móviles.</li>
                                <li>Acceso a nuestro sistema de inteligencia de negocios.</li>
                            </span>
                            </ul>
                            </span>
                            <div class="show-more-desktop">
                                <ShowMore textId="textTecDesktop" loadEffect={true} component={ShowMoreWithStyles} onClick={() => this.changeColorTitle("titleTec")}/>
                            </div>
                        </div>
                    </div>
                    <div class="show-more-service">
                        <ShowMore textId="text-service-tec" loadEffect={true}/>
                    </div>
                    
                </div>
            </div>
        );
    }
}



export default Servicio;


// WEBPACK FOOTER //
// ./src/components/Servicio.js